import { useContext, useLayoutEffect } from 'react'
import CookiesContext from 'react-cookie/es6/CookiesContext'
import { COOKIE_NAME_CURRENCY, COOKIE_NAME_SALES_AGENT_GROUP, COOKIE_NAME_USER_GROUP } from '../../constants'
import { useVary } from '../../hooks/useVary'

const Vary = () => {
	const { update: updateVary } = useVary()

	const cookies = useContext(CookiesContext)

	useLayoutEffect(() => {
		const cookiesChangeCallback = ({ name }) => {
			if (
				!name.includes(COOKIE_NAME_USER_GROUP) &&
				!name.includes(COOKIE_NAME_SALES_AGENT_GROUP) &&
				!name.includes(COOKIE_NAME_CURRENCY)
			) {
				// skip other cookies
				return
			}

			updateVary()
		}
		cookies.addChangeListener(cookiesChangeCallback)

		return () => {
			cookies.removeChangeListener(cookiesChangeCallback)
		}
	}, [cookies, updateVary])

	return null
}

export default Vary
